import React, { useEffect, useState } from "react";
import { NetworkBlogResponse } from "./post_model";
import "../../styles/blog.css"

const Blog = () => {
    const [data, setBlogs] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchBlogs = async () => {
            setLoading(true);
            try {
                // const response = await fetch("/rest/v1.1/sites/conranet.wordpress.com/posts/");
                const response = await fetch("https://public-api.wordpress.com/rest/v1.1/sites/conranet.wordpress.com/posts/");
                const data = await response.json();
                setBlogs(data);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.error("Failed to fetch blogs:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);
    return (
        <div>

            <div className="container-top-2">
                <h1 className="h1-48-600">
                    Discover New
                    <span> Blogs </span>
                    Here
                </h1>
                {/* <h1>
                    Discover New <span className="highlight">Blogs</span> Here
                </h1> */}
                <p className="ft-para">All the blogs and content related to ConRa have been posted here. You can find them easily without a problem</p>
                <input className="search" type="text" placeholder="Search..." />
            </div>

            <div className="popular">
                <h2>Popular Blogs</h2>
            </div>
            <div className="popular">
                <div className="popular-card">
                    <h3>How AI is Transforming Construction Management</h3>
                    <p>
                        Explore the ways AI is reshaping construction management through enhanced inspection scheduling and compliance
                        tracking. Minimize compliance risks, ensure inspections are conducted on time, and effortlessly generate reports.
                    </p>
                    <a>Read More →</a>
                </div>
            </div>

            {/* <BlogList data={data} /> */}
            <div>
                {loading ? <Shimmer /> : <BlogList data={data} />}
            </div>

        </div>
    );
};

const Shimmer = () => (
    <div className="shimmer-container">
        {[...Array(5)].map((_, i) => (
            <div key={i} className="shimmer-item"></div>
        ))}
    </div>
);

function BlogList({ data }) {
    if (!data || !data.posts) {
        return <div>No blog posts available.</div>;
    }

    return (
        <div className="blogs">
            <h2>Blogs</h2>
            <div className="grid-blog">
                {console.log(data.posts)}
                {data.posts.map((post, i) => (
                    <div className="blogs-item" key={post.ID}>
                        {post.featured_image ? (
                            <img src={post.featured_image} alt={post.title} className="image-placeholder" />
                        ) : (
                            <div className="image-placeholder">No Image Available</div>
                        )}
                        <h2 className="popular-card-h3">Blog Title {post.title}</h2>
                        <p className="excerpt-limit" dangerouslySetInnerHTML={{ __html: post.excerpt }}></p>
                        <a href={post.short_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="read-more"
                        >Read More →</a>
                    </div>
                ))}
            </div>
        </div>
    );
}

BlogList.propTypes = {
    data: NetworkBlogResponse,
};

export default Blog;
